(function () {
  if (customElements.get('collection-subnav')) return;

  class CollectionSubnav extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.collection-subnav__list');
      this.links = Array.from(this.querySelectorAll('.collection-subnav__link[href]'));
      if (!this.list) return;

      this.onScroll = this.updateOverflow.bind(this);
      this.list.addEventListener('scroll', this.onScroll, { passive: true });

      this.onArrowClick = this.scrollByDirection.bind(this);
      this.arrows = Array.from(this.querySelectorAll('.collection-subnav__arrow'));
      this.arrows.forEach((arrow) => arrow.addEventListener('click', this.onArrowClick));

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.onScroll);
        this.resizeObserver.observe(this.list);
      } else {
        window.addEventListener('resize', this.onScroll);
      }

      this.syncActiveFromUrl();
      this.revealActive();
      this.updateOverflow();
    }

    disconnectedCallback() {
      if (this.list) this.list.removeEventListener('scroll', this.onScroll);
      if (this.arrows) this.arrows.forEach((arrow) => arrow.removeEventListener('click', this.onArrowClick));
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      } else {
        window.removeEventListener('resize', this.onScroll);
      }
    }

    normalize(url) {
      const params = new URLSearchParams(url.search);
      params.sort();
      const query = params.toString();
      return url.pathname.replace(/\/+$/, '') + (query ? '?' + query : '');
    }

    // Liquid marks the active tile by path only; a manual link that targets
    // a filtered or sorted URL can only be matched against the query string here.
    syncActiveFromUrl() {
      const current = this.normalize(window.location);
      const matches = this.links.filter((link) => {
        try {
          return this.normalize(new URL(link.href, window.location.origin)) === current;
        } catch (error) {
          return false;
        }
      });
      if (!matches.length) return;

      const match = matches.find((link) => link.classList.contains('is-active')) || matches[0];

      this.links.forEach((link) => {
        const isActive = link === match;
        link.classList.toggle('is-active', isActive);
        if (isActive) {
          link.setAttribute('aria-current', 'page');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    revealActive() {
      const active = this.querySelector('.collection-subnav__link.is-active');
      if (!active || this.list.scrollWidth - this.list.clientWidth <= 1) return;

      const listRect = this.list.getBoundingClientRect();
      const activeRect = active.getBoundingClientRect();
      const offset = activeRect.left - listRect.left + this.list.scrollLeft;
      this.list.scrollLeft = Math.max(0, offset - (this.list.clientWidth - activeRect.width) / 2);
    }

    scrollByDirection(event) {
      const direction = Number(event.currentTarget.dataset.direction) || 1;
      this.list.scrollBy({ left: direction * this.list.clientWidth * 0.75, behavior: 'smooth' });
    }

    updateOverflow() {
      const { scrollWidth, clientWidth, scrollLeft } = this.list;
      const canScroll = scrollWidth - clientWidth > 1;
      this.classList.toggle('collection-subnav--overflow-start', canScroll && scrollLeft > 1);
      this.classList.toggle('collection-subnav--overflow-end', canScroll && scrollLeft + clientWidth < scrollWidth - 1);
    }
  }

  customElements.define('collection-subnav', CollectionSubnav);
})();
